import axios from "./axios";

/**
 * 查詢車軸數量
 * @returns 
 */
const getAxleCount = () => {
  return axios
    .get(`/protected/api/v1/vss-view/axleCount`)
    .then((res) => res.data);
};

/**
 * 查詢駕照類別詳情
 * @param {*} code
 */
const getDrivingLicenseTypeByCode = (code) => {
  return axios
    .get(`/protected/api/v1/vss-view/drivingLicenseType?code=${code}`)
    .then((res) => res.data);
};

/**
 * 查詢駕照類別
 * @param {*} key
 */
const getDrivingLicenseTypes = (key = null) => {
  return axios
    .get(
      `/protected/api/v1/vss-view/drivingLicenseTypes${
        key ? `?key=${key}` : ""
      }`
    )
    .then((res) => res.data);
};

/**
 * 查詢證件類別詳情
 * @param {*} code
 */
const getIdentityTypeByCode = (code) => {
  return axios
    .get(`/protected/api/v1/vss-view/identityType?code=${code}`)
    .then((res) => res.data);
};

/**
 * 查詢證件類別
 * @param {*} key
 */
const getIdentityTypes = (key = null) => {
  return axios
    .get(`/protected/api/v1/vss-view/identityTypes${key ? `?key=${key}` : ""}`)
    .then((res) => res.data);
};

/**
 * 查詢公司證件類別
 */
const getCompanyIdentityTypes = () => {
  return [
    { value: "CO", label: "自然人商業企業主" },
    { value: "EM", label: "商業企業" },
    { value: "SO", label: "法人商業企業主" },
  ];
};

/**
 * 查詢國籍詳情
 * @param {*} code
 */
const getNationalityByCode = (code) => {
  return axios
    .get(`/protected/api/v1/vss-view/nationality?code=${code}`)
    .then((res) => res.data);
};

/**
 * 查詢國籍
 * @param {*} key
 */
const getNationalitys = (key = null) => {
  return axios
    .get(`/protected/api/v1/vss-view/nationalitys${key ? `?key=${key}` : ""}`)
    .then((res) => res.data);
};

/**
 * 查詢國籍詳情
 * @param {*} code
 */
const getSexByCode = (code) => {
  return axios
    .get(`/protected/api/v1/vss-view/sex?code=${code}`)
    .then((res) => res.data);
};

/**
 * 查詢國籍
 * @param {*} key
 */
const getsexs = (key = null) => {
  return axios
    .get(`/protected/api/v1/vss-view/sexs${key ? `?key=${key}` : ""}`)
    .then((res) => res.data);
};

/**
 * 查詢G類證件類別
 * @returns
 */
const getHzmbGIdType = () => {
  return axios
    .get(`/protected/api/v1/vss-view/identityTypes/hzmbG`)
    .then((res) => res.data);
};

/**
 * 根據登記類型查詢G類證件類別
 * @param {*} registerType
 * @returns
 */
const getHzmbGByType = (registerType) => {
  return axios
    .get(
      `/protected/api/v1/vss-view/identityTypes/hzmbG/by-type?registerType=${registerType}`
    )
    .then((res) => res.data);
};

/**
 * 根據登記類型查詢G類證件類別PUBLIC
 * @param {*} registerType
 * @returns
 */
const getHzmbGByTypePublic = (registerType) => {
  return axios
    .get(
      `/public/api/v1/vss-view/identityTypes/hzmbG/by-type?registerType=${registerType}`
    )
    .then((res) => res.data);
};

export default {
  getAxleCount,
  getDrivingLicenseTypeByCode,
  getDrivingLicenseTypes,
  getIdentityTypeByCode,
  getIdentityTypes,
  getCompanyIdentityTypes,
  getNationalityByCode,
  getNationalitys,
  getSexByCode,
  getsexs,
  getHzmbGIdType,
  getHzmbGByType,
  getHzmbGByTypePublic,
};
